function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Control, Rotate, Zoom as BaseZoom } from "ol/control";
import { CLASS_UNSELECTABLE, CLASS_CONTROL } from "ol/css";
import { MapEvent } from "ol";
import pointer from "./pointer_images";
import { createElement } from "@maplat/core";
var control_settings = {};
var delegator = {
  compass: "compass.png",
  border: "border.png",
  attr: "attr.png",
  gps: "gps.png",
  zoom_plus: "plus.png",
  zoom_minus: "minus.png",
  help: "help.png",
  home: "home.png",
  hide_marker: "hide_marker.png",
  share: "share.png",
  slider_in_help: "slider.png",
  favicon: "favicon.png"
};
function hexRgb(hex) {
  var ret = {};
  if (hex.match(/^#?([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i)) {
    ret.red = parseInt(RegExp.$1, 16);
    ret.green = parseInt(RegExp.$2, 16);
    ret.blue = parseInt(RegExp.$3, 16);
  } else if (hex.match(/^#?([0-9A-F])([0-9A-F])([0-9A-F])$/i)) {
    ret.red = parseInt("".concat(RegExp.$1).concat(RegExp.$1), 16);
    ret.green = parseInt("".concat(RegExp.$2).concat(RegExp.$2), 16);
    ret.blue = parseInt("".concat(RegExp.$3).concat(RegExp.$3), 16);
  }
  return ret;
}
export function setControlSettings(options) {
  control_settings = options;
  Object.keys(control_settings).forEach(function (key) {
    if (delegator[key]) {
      pointer[delegator[key]] = control_settings[key];
    }
  });
}

/**
 * @classdesc
 * A slider type of control for zooming.
 *
 * Example:
 *
 *     map.addControl(new ol.control.SliderNew());
 *
 * @constructor
 * @extends {ol.control.Control}
 * @param {olx.control.SliderNewOptions=} opt_options Zoom slider options.
 * @api
 */
export var SliderNew = /*#__PURE__*/function (_Control) {
  _inherits(SliderNew, _Control);
  var _super = _createSuper(SliderNew);
  function SliderNew(opt_options) {
    var _this;
    _classCallCheck(this, SliderNew);
    var options = opt_options ? opt_options : {};
    var containerElement = document.createElement("input"); // eslint-disable-line no-undef
    containerElement.type = "range";
    containerElement.min = 0;
    containerElement.max = 1;
    containerElement.value = 1;
    containerElement.step = 0.01;
    var render = options.render ? options.render : SliderNew.render;
    _this = _super.call(this, {
      element: containerElement,
      render: render
    });
    var className = options.className !== undefined ? options.className : "ol-slidernew";
    _this.set("slidervalue", 0);
    containerElement.title = options.tipLabel;
    containerElement.className = "".concat(className, " ").concat(CLASS_UNSELECTABLE, " ").concat(CLASS_CONTROL);
    containerElement.addEventListener("click", function (ev) {
      ev.stopPropagation();
    });
    containerElement.addEventListener("pointerdown", function (ev) {
      ev.stopPropagation();
    });
    containerElement.addEventListener("pointerup", function (ev) {
      ev.stopPropagation();
    });

    // eslint-disable-next-line no-unused-vars
    containerElement.addEventListener("input", function (ev) {
      _this.set("slidervalue", 1 - _this.element.value);
    });
    if (control_settings["slider_color"]) {
      var rgb = hexRgb(control_settings["slider_color"]);
      containerElement.addClass("ol-slider-originalcolor");
      var sheets = document.styleSheets;
      var sheet = sheets[sheets.length - 1];
      sheet.insertRule(".maplat.with-opacity .ol-slider-originalcolor.".concat(className, "::-webkit-slider-thumb { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.5); } .maplat.with-opacity .ol-slider-originalcolor.").concat(className, "::-moz-range-thumb { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.5); } .maplat.with-opacity .ol-slider-originalcolor.").concat(className, "[disabled]::-webkit-slider-thumb { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.2); } .maplat.with-opacity .ol-slider-originalcolor.").concat(className, "[disabled]::-moz-range-thumb { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.2); } .maplat.with-opacity .ol-slider-originalcolor.").concat(className, ":not([disabled])::-webkit-slider-thumb:hover { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.7); } .maplat.with-opacity .ol-slider-originalcolor.").concat(className, ":not([disabled])::-moz-range-thumb:hover { background: rgba(").concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ", 0.7); }"), sheet.cssRules.length);
    }
    return _this;
  }

  /**
   * @inheritDoc
   */
  _createClass(SliderNew, [{
    key: "setMap",
    value: function setMap(map) {
      _get(_getPrototypeOf(SliderNew.prototype), "setMap", this).call(this, map);
      if (map) {
        map.render();
      }
    }

    /**
     * Update the SliderCommon element.
     * @param {ol.MapEvent} mapEvent Map event.
     * @this {ol.control.SliderCommon}
     * @api
     */
  }, {
    key: "setEnable",
    value: function setEnable(cond) {
      var elem = this.element;
      if (cond) {
        elem.disabled = false;
      } else {
        elem.disabled = true;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(res) {
      console.log("setValue: ".concat(res));
      this.set("slidervalue", res);
      this.element.value = 1 - res;
    }
  }], [{
    key: "render",
    value: function render(mapEvent) {
      if (!mapEvent.frameState) {
        return;
      }
    }
  }]);
  return SliderNew;
}(Control);
export var CustomControl = /*#__PURE__*/function (_Control2) {
  _inherits(CustomControl, _Control2);
  var _super2 = _createSuper(CustomControl);
  function CustomControl(optOptions) {
    var _this2;
    _classCallCheck(this, CustomControl);
    var options = optOptions || {};
    var element = document.createElement("div"); // eslint-disable-line no-undef

    _this2 = _super2.call(this, {
      element: element,
      target: options.target,
      render: options.render
    });
    var button = document.createElement("button"); // eslint-disable-line no-undef
    button.setAttribute("type", "button");
    button.title = options.tipLabel;
    var span = document.createElement("span"); // eslint-disable-line no-undef
    span.innerHTML = options.character;
    button.appendChild(span);
    var timer;
    var touchstart;
    var self = _assertThisInitialized(_this2);
    button.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    button.addEventListener("mouseup", function (e) {
      if (!touchstart) {
        if (timer) {
          if (options.long_callback) {
            clearTimeout(timer); // eslint-disable-line no-undef
          }
          timer = null;
          options.callback.apply(self);
        }
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("mousemove", function (e) {
      e.stopPropagation();
    }, false);
    button.addEventListener("mousedown", function (e) {
      if (!touchstart) {
        if (options.long_callback) {
          timer = setTimeout(function () {
            // eslint-disable-line no-undef
            timer = null;
            options.long_callback.apply(self);
          }, 1500);
        } else {
          timer = true;
        }
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("touchstart", function (e) {
      touchstart = true;
      if (options.long_callback) {
        timer = setTimeout(function () {
          // eslint-disable-line no-undef
          timer = null;
          options.long_callback.apply(self);
        }, 1500);
      } else {
        timer = true;
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("touchend", function (e) {
      if (timer) {
        if (options.long_callback) {
          clearTimeout(timer); // eslint-disable-line no-undef
        }
        timer = null;
        options.callback.apply(self);
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("mouseout", function (e) {
      if (options.long_callback) {
        clearTimeout(timer); // eslint-disable-line no-undef
      }
      timer = null;
      e.stopPropagation();
    }, false);
    button.addEventListener("dblclick", function (e) {
      e.preventDefault();
    }, false);
    element.className = "".concat(options.cls, " ol-unselectable ol-control");
    element.appendChild(button);
    return _this2;
  }
  return _createClass(CustomControl);
}(Control);
export var GoHome = /*#__PURE__*/function (_CustomControl) {
  _inherits(GoHome, _CustomControl);
  var _super3 = _createSuper(GoHome);
  function GoHome(optOptions) {
    var _this3;
    _classCallCheck(this, GoHome);
    var options = optOptions || {};
    options.character = control_settings["home"] ? "<img src=\"".concat(control_settings["home"], "\">") : '<i class=\"fa fa-home fa-lg\"></i>';
    options.cls = "home";
    options.callback = function () {
      var source = this.getMap().getLayers().item(0).getSource();
      source.goHome();
    };
    _this3 = _super3.call(this, options);
    if (control_settings["home"]) {
      var button = _this3.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this3;
  }
  return _createClass(GoHome);
}(CustomControl);
export var SetGPS = /*#__PURE__*/function (_CustomControl2) {
  _inherits(SetGPS, _CustomControl2);
  var _super4 = _createSuper(SetGPS);
  function SetGPS(optOptions) {
    var _this4;
    _classCallCheck(this, SetGPS);
    var options = optOptions || {};
    options.character = control_settings["gps"] ? "<img src=\"".concat(control_settings["gps"], "\">") : '<i class=\"fa fa-crosshairs fa-lg\"></i>';
    options.cls = "gps";
    options.render = function (mapEvent) {
      var frameState = mapEvent.frameState;
      if (!frameState) {
        return;
      }
      var map = this.getMap();
      if (map.geolocation) {
        var tracking = map.geolocation.getTracking();
        var receiving = this.element.classList.contains("disable");
        if (receiving && !tracking) {
          this.element.classList.remove("disable");
        } else if (!receiving && tracking) {
          this.element.classList.add("disable");
        }
      }
    };
    options.callback = function () {
      var receiving = this.element.classList.contains("disable");
      var map = this.getMap();
      map.handleGPS(!receiving);
      if (receiving) {
        this.element.classList.remove("disable");
      } else {
        this.element.classList.add("disable");
      }
    };
    _this4 = _super4.call(this, options);
    if (control_settings["gps"]) {
      var button = _this4.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this4;
  }
  return _createClass(SetGPS);
}(CustomControl);
export var CompassRotate = /*#__PURE__*/function (_Rotate) {
  _inherits(CompassRotate, _Rotate);
  var _super5 = _createSuper(CompassRotate);
  function CompassRotate(optOptions) {
    var _this5;
    _classCallCheck(this, CompassRotate);
    var options = optOptions || {};
    options.autoHide = false;
    var span = document.createElement("span"); // eslint-disable-line no-undef
    span.innerHTML = control_settings["compass"] ? "<img src=\"".concat(control_settings["compass"], "\">") : '<i class=\"fa fa-compass fa-lg ol-compass-fa\"></i>';
    options.label = span;
    options.render = function (mapEvent) {
      var _this6 = this;
      var frameState = mapEvent.frameState;
      if (!frameState) {
        return;
      }
      var view = this.getMap().getView();
      var rotation = frameState.viewState.rotation;
      var center = view.getCenter();
      var zoom = view.getDecimalZoom();
      if (rotation != this.rotation_ || center[0] != this.center_[0] || center[1] != this.center_[1] || zoom != this.zoom_) {
        if (!this.getMap().northUp) {
          var contains = this.element.classList.contains("disable");
          if (!contains && rotation === 0) {
            this.element.classList.add("disable");
          } else if (contains && rotation !== 0) {
            this.element.classList.remove("disable");
          }
        }
        var self = this;
        var layer = this.getMap().getLayers().item(0);
        var source = layer.getSource ? layer.getSource() : layer.getLayers().item(0).getSource();
        if (!source) {
          var transform = "rotate(0rad)";
          self.label_.style.msTransform = transform;
          self.label_.style.webkitTransform = transform;
          self.label_.style.transform = transform;
          return;
        }
        source.viewpoint2MercsAsync().then(function (mercs) {
          var direction = source.mercs2MercViewpoint(mercs)[2];
          var transform = "rotate(".concat(direction, "rad)");
          self.label_.style.msTransform = transform;
          self.label_.style.webkitTransform = transform;
          self.label_.style.transform = transform;
          if (_this6.getMap().northUp) {
            console.log(direction);
            var _contains = self.element.classList.contains("disable");
            if (!_contains && Math.abs(direction) < 0.1) {
              self.element.classList.add("disable");
            } else if (_contains && Math.abs(direction) >= 0.1) {
              self.element.classList.remove("disable");
            }
          }
        });
      }
      this.rotation_ = rotation;
      this.center_ = center;
      this.zoom_ = zoom;
    };
    _this5 = _super5.call(this, options);
    if (control_settings["compass"]) {
      var button = _this5.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    _this5.center_ = [];
    _this5.zoom_ = undefined;
    _this5.callResetNorth_ = function () {
      var layer = _this5.getMap().getLayers().item(0);
      var source = layer.getSource ? layer.getSource() : layer.getLayers().item(0).getSource();
      source.resetCirculation();
    };
    return _this5;
  }
  return _createClass(CompassRotate);
}(Rotate);
export var Share = /*#__PURE__*/function (_CustomControl3) {
  _inherits(Share, _CustomControl3);
  var _super6 = _createSuper(Share);
  function Share(optOptions) {
    var _this7;
    _classCallCheck(this, Share);
    var options = optOptions || {};
    options.character = control_settings["share"] ? "<img src=\"".concat(control_settings["share"], "\">") : '<i class=\"fa fa-share-alt-square fa-lg\"></i>';
    options.cls = "ol-share";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "share"
      }));
    };
    _this7 = _super6.call(this, options);
    if (control_settings["share"]) {
      var button = _this7.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this7;
  }
  return _createClass(Share);
}(CustomControl);
export var Border = /*#__PURE__*/function (_CustomControl4) {
  _inherits(Border, _CustomControl4);
  var _super7 = _createSuper(Border);
  function Border(optOptions) {
    var _this8;
    _classCallCheck(this, Border);
    var options = optOptions || {};
    options.character = control_settings["border"] ? "<img src=\"".concat(control_settings["border"], "\">") : '<i class=\"fa fa-clone fa-lg\"></i>';
    options.cls = "ol-border";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "border"
      }));
    };
    _this8 = _super7.call(this, options);
    if (control_settings["border"]) {
      var button = _this8.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this8;
  }
  return _createClass(Border);
}(CustomControl);
export var Maplat = /*#__PURE__*/function (_CustomControl5) {
  _inherits(Maplat, _CustomControl5);
  var _super8 = _createSuper(Maplat);
  function Maplat(optOptions) {
    var _this9;
    _classCallCheck(this, Maplat);
    var options = optOptions || {};
    options.character = control_settings["help"] ? "<img src=\"".concat(control_settings["help"], "\">") : '<i class=\"fa fa-question-circle fa-lg\"></i>';
    options.cls = "ol-maplat";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "help"
      }));
    };
    _this9 = _super8.call(this, options);
    if (control_settings["help"]) {
      var button = _this9.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this9;
  }
  return _createClass(Maplat);
}(CustomControl);
export var Copyright = /*#__PURE__*/function (_CustomControl6) {
  _inherits(Copyright, _CustomControl6);
  var _super9 = _createSuper(Copyright);
  function Copyright(optOptions) {
    var _this10;
    _classCallCheck(this, Copyright);
    var options = optOptions || {};
    options.character = control_settings["attr"] ? "<img src=\"".concat(control_settings["attr"], "\">") : '<i class=\"fa fa-info-circle fa-lg\"></i>';
    options.cls = "ol-copyright";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "copyright"
      }));
    };
    _this10 = _super9.call(this, options);
    if (control_settings["attr"]) {
      var button = _this10.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this10;
  }
  return _createClass(Copyright);
}(CustomControl);
export var HideMarker = /*#__PURE__*/function (_CustomControl7) {
  _inherits(HideMarker, _CustomControl7);
  var _super10 = _createSuper(HideMarker);
  function HideMarker(optOptions) {
    var _this11;
    _classCallCheck(this, HideMarker);
    var options = optOptions || {};
    options.character = control_settings["hide_marker"] ? "<img src=\"".concat(control_settings["hide_marker"], "\">") : '<i class=\"fa fa-map-marker fa-lg\"></i>';
    options.cls = "ol-hide-marker";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "hideMarker"
      }));
    };
    options.long_callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "hideLayer"
      }));
    };
    _this11 = _super10.call(this, options);
    if (control_settings["hide_marker"]) {
      var button = _this11.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this11;
  }
  return _createClass(HideMarker);
}(CustomControl);
export var Zoom = /*#__PURE__*/function (_BaseZoom) {
  _inherits(Zoom, _BaseZoom);
  var _super11 = _createSuper(Zoom);
  function Zoom() {
    var _this12;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Zoom);
    if (control_settings["zoom_plus"]) {
      options.zoomInLabel = createElement("<img src=\"".concat(control_settings["zoom_plus"], "\">"))[0];
    }
    if (control_settings["zoom_minus"]) {
      options.zoomOutLabel = createElement("<img src=\"".concat(control_settings["zoom_minus"], "\">"))[0];
    }
    _this12 = _super11.call(this, options);
    if (control_settings["compass"]) {
      var buttons = _this12.element.querySelectorAll("button");
      buttons.forEach(function (button) {
        button.style.backgroundColor = "rgba(0,0,0,0)";
      });
    }
    return _this12;
  }
  return _createClass(Zoom);
}(BaseZoom);